import type { TransformedChatEntry } from '~services/api/bots/types';
import { Entity } from '~store/utils/entity';

export const chatEntity = new Entity<TransformedChatEntry>();
